/** 사이트 약관 키 (본문은 어드민 사이트 약관에서 관리, GET /v1/site-terms/{key}) */
export enum SITE_TERM_KEY {
  TERM_COURSE_GENERAL = 'term_course_general', // 내학습(영어교실 외) 약관
  TERM_COURSE_JEMM = 'term_course_jemm', // JEMM 회원약관(회원용)
  TERM_MARKETING_CONSENT = 'term_marketing_consent', // 프로모션 정보 수신 동의
  TERM_PRIVACY_CONSENT = 'term_privacy_consent', // 개인정보 수집·이용 동의
  TERM_PRIVACY_POLICY = 'term_privacy_policy', // 개인정보처리방침
  TERM_REFUND_POLICY = 'term_refund_policy', // 환불규정
  TERM_SERVICE = 'term_service', // 이용약관
}

/** 사이트 약관 조회 응답 */
export interface SiteTerm {
  key: SITE_TERM_KEY;
  title: string;
  content: string; // 약관 본문 (HTML)
  version: number; // 수정마다 +1, 동의 수집 시 기록되는 버전
  updatedAt: string;
}
